<template>
    <div
        style="display: flex; flex-flow: column; min-height: 500px; justify-content: center; align-items: center;"
    >
        <span
        class="fa fa-spinner fa-4x animated rotateIn infinite loadingState"
        style="color: #1a93ca;"
        ></span>
        <h3>Wait a second..</h3>
    </div>
</template>


<script>
export default {
    name: "LoadingComponent"
}
</script>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/LoadingComponent.vue